import AccessAPI from '../../store/AccessAPI';
import { UIConstants } from '../../shared/models/Constants';
import { AccessRequestSelfRemoval } from '../../shared/models/UserAccess.model';
import { BatchExecutionResult, RemoveActionContext } from './MyAccessRequests.types';
import { executeSequential } from './MyAccessRequests.executor';
import { evaluateRemoveEligibility } from './MyAccessRequests.lifecycleEligibility';

const toApiErrorMessage = (error: any, fallbackMessage: string): string => {
  return error?.response?.data?.message || error?.message || fallbackMessage;
};

export async function executeRemoveSelected(context: RemoveActionContext): Promise<BatchExecutionResult> {
  return executeSequential(context.selectedItems, {
    validate: (item) => {
      const eligibility = evaluateRemoveEligibility(item, {
        allItems: context.allItems || [],
        approvedAccesses: context.approvedAccesses || []
      });
      if (!eligibility.isEligible) {
        return eligibility.reason || 'Only approved/completed access can be removed';
      }

      if (context.isExternalAADTenant && !item.roleAssignmentId) {
        return 'Missing roleAssignmentId for external tenant';
      }

      return null;
    },
    execute: async (item) => {
      const payload: AccessRequestSelfRemoval = {
        tenantId: context.tenantId,
        roleId: item.roleId,
        businessGroup: item.businessGroup || (typeof item.attributes === 'string' ? item.attributes : null),
        permissionLevel: item.permissionLevel,
        roleAssignmentId: context.isExternalAADTenant ? item.roleAssignmentId : null
      };

      try {
        const response = await AccessAPI.removeRoleAccess(payload);
        if (response?.status === 200) {
          return { ok: true, message: 'Access removed' };
        }

        return { ok: false, message: response?.message || UIConstants.Messages.RemoveFailure };
      } catch (error) {
        return { ok: false, message: toApiErrorMessage(error, UIConstants.Messages.RemoveFailure) };
      }
    },
    onSuccess: (item, message) => context.updateRowExecutionState(item.requestId, 'success', message),
    onFailure: (item, message) => context.updateRowExecutionState(item.requestId, 'failed', message)
  });
}
